<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <g-table :fields="fields" :per-page=20 :table-data="tableData" bordered caption="Module List" hover small striped>

        <b-nav pills small slot="actions" class="float-right">
          <b-nav-item active v-b-modal.module-composer><i class="fa fa-plus"></i> Add Module</b-nav-item>
        </b-nav>
      </g-table>
    </div>

    <b-modal id="module-composer"
             title="Add New Module"
             ok-title="Save"
             @ok="saveModule"
             @cancel="clearForm">
      <form action="">
        <b-form-group
          id="module-composer"
          label="Module code"
          label-for="module-code"
          :state="module.code && module.code.length >= 4"
        >
          <b-form-input id="module-code" v-model="module.code"
                        :state="module.code && module.code.length >= 4" trim></b-form-input>
        </b-form-group>

        <b-form-group
          id="module-composer"
          label="Name"
          label-for="module-name"
          :state="module.name && module.name.length >= 4"
        >
          <b-form-input id="module-name" v-model="module.name"
                        :state="module.name && module.name.length >= 4" trim></b-form-input>
        </b-form-group>

        <b-form-group
          id="module-composer"
          label="Description"
          label-for="module-description"
        >
          <b-form-textarea id="module-description" v-model="module.description" trim></b-form-textarea>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
  import moduleService from '@/services/moduleService'
  import genericTable from '@/components/GenericTable'
	import toastService from '@/services/toastService'

  export default {
    name: 'Module',
    components: {
      "g-table": genericTable
    },
    data: () => {
      return {
        modules: [],
        module: {
          code: '',
          name: '',
          description: '',
        },
        fields: [
          {key: 'code', label: 'Code', sortable: true},
          {key: 'name', label: 'Name', sortable: true},
        ],
      }
    },
    computed: {
      tableData() {
        return this.modules
      }
    },
    methods: {
      fetchModuleList() {
        moduleService.getModuleList((data) => {
          this.modules = data;
        }, (error) => {
					toastService.showErrorToast("Could not fetch module list" + error);
        });
      },
      saveModule(event) {
        event.preventDefault();

        if (!this.checkFormValidity()) {
					toastService.showErrorToast("Please complete form correctly");

          return;
        }

        moduleService.storeModule(this.module, () => {
          toastService.showSuccessToast("New Module Added");
          this.clearForm();
          this.fetchModuleList();

          this.$bvModal.hide('module-composer');
        }, (error) => {
					toastService.showErrorToast("Could not save module" + error);
        });
      },
      clearForm() {
        this.module.code = '';
        this.module.name = '';
        this.module.description = '';
      },
      checkFormValidity() {
        const code = this.module.code && this.module.code.length >= 4;
        const name = this.module.name && this.module.name.length >= 4;

        return code || name;
      }
    },
    mounted() {
      this.fetchModuleList();
    }
  }
</script>
